export class JointCompletionCertificate {
    calculationType: number;
    projectDetailJCC: ProjectDetailJCC;
    jointIdDetails: JointIdDetails;
    standardOrCustomFlangeDetail: StandardOrCustomFlangeDetail;
    clampDetailJCC: ClampJCC;
    engineeredJointJCC: EngineeredJointJCC;
    values: Values;
    tensionDetails?: TensionDetails;
    torqueDetails?: TorqueDetails;
    traceabilityDetails?: TraceabilityDetailsJCC;
    comments: string;
    warnings?: string[];
    language: string;
    barCodeNumber?: string;
}

export class ProjectDetailJCC {
    customer?: string;
    site?: string;
    projectNumber?: string;
    projectName?: string;
}

export class JointIdDetails {
    jointId?: string;
    permanentTagNumber?: string;
    jointLocation?: string;
    vesselRef?: string;
    pAndIdNumber?: string;
    isoNumber?: string;
    workTestPackNumber?: string;
    lineNumber?: string;
}

export class StandardOrCustomFlangeDetail {
    jointType?: string;
    jointSize?: string;
    jointMaterial?: string;
    jointRating?: string;
    boltQuantity?: string;
    boltDiameter?: string;
    boltCoating?: string;
    boltMaterial?: string;
    gasketType?: string;
    nutAf?: string;
    gasketFiller?: string;
}

export class Values {
    residualBoltStressMetric?: string;
    residualBoltStressImperial?: string;
    residualBoltLoadMetric?: string;
    residualBoltLoadImperial?: string;
    referenceDocument?: string;
}

export class TensionDetails {
    pressurePass1Metric?: string;
    pressurePass1Imperial?: string;
    pressurePass2Metric?: string;
    pressurePass2Imperial?: string;
    pressurePass3Metric?: string;
    pressurePass3Imperial?: string;
    pressurePass4Metric?: string;
    pressurePass4Imperial?: string;
    gripLengthMetric?: string; // in calculation api response it is refereed as "Joint Thickness"
    gripLengthImperial?: string;
    procedurePercentage?: string;
    noTools?: string;
    tensionToolRef?: string;
    pumpOrGaugeSerialNo?: string;
    tensionToolSerialNo?: string;
}

export class TorqueDetails {
    lubricant?: string;
    torqueToolRef?: string;
    noTools?: string;
    pumpOrGaugeSerialNo?: string;
    torqueToolSerialNo?: string;
    torqueValueMetric?: string;
    torqueValueImperial?: string;
    pressureValueMetric?: string;
    pressureValueImperial?: string;

    // torque values
    torquePass1Metric: string;
    torquePass1Imperial: string;
    torquePass2Metric: string;
    torquePass2Imperial: string;
    torquePass3Metric: string;
    torquePass3Imperial: string;
    torquePass4Metric: string;
    torquePass4Imperial: string;

    // pump pressure value
    pumpPressurePass1Metric: string;
    pumpPressurePass1Imperial: string;
    pumpPressurePass2Metric: string;
    pumpPressurePass2Imperial: string;
    pumpPressurePass3Metric: string;
    pumpPressurePass3Imperial: string;
    pumpPressurePass4Metric: string;
    pumpPressurePass4Imperial: string;
}

export class TraceabilityDetailsJCC {
    instructedBy?: string;
    instructedCompany?: string;
    instructedPosition?: string;
    assembledBy?: string;
    assembledByCompany?: string;
    assembledDate?: string;
    tightenedBy1?: string;
    tightenedBy1Company?: string;
    tightened1Date?: string;
    tightenedBy2?: string;
    tightenedBy2Company?: string;
    tightened2Date?: string;
    reportCompletedBy?: string;
    reportCompletedDate?: string;
    customerAcceptance?: string;
    customerAcceptanceCompany?: string;
    customerAcceptanceCompanyDate?: string;
}

export class ClampJCC {
    manufacturer: string;
    clampMaterial: string;
    boltDiameter: string;
    nutAf: string;
    boltQuantity: string;
    sealRingMaterial: string;
    clampSize: string;
    hubMaterial: string;
    boltMaterial: string;
    boltCoating: string;
    gasketFiller: string;
}

export class EngineeredJointJCC {
    jointConfiguration: string;
    jointMaterial1: string;
    boltDiameter: string;
    nutAf: string;
    boltQuantity: string;
    gasketType: string;
    jointThicknessMetric: string;
    jointThicknessImperial: string;
    jointMaterial2: string;
    boltMaterial: string;
    boltCoating: string;
    gasketFiller: string;
}
